<div class="movie-selector">
  <!-- {{options?.length}} -->
  <span class="search-icon" [inlineSVG]="'/icons/icon-search.svg'"></span>
  <mat-form-field [floatLabel]="'auto'">
    <input
      type="text"
      matInput
      (input)="onValueChange($event)"
      [value]="inputValue"
      [matAutocomplete]="autoComplete"
      [placeholder]="placeholder | transloco"
    />
    <span (click)="resetValue($event)" class="icon-close cta-btn" [inlineSVG]="'/icons/icon-close.svg'"></span>
    <mat-autocomplete
      #autoComplete="matAutocomplete"
      class="movie-selector-mat-autocomplete"
      classlist="movie-selector-mat-autocomplete"
      [displayWith]="displayFn"
      (closed)="onAutocompleteClosed()"
    >
      @if (!optionsTemplate) {
        @for (entry of entries; track trackByEntry($index, entry)) {
          <mat-option class="movie-selector-mat-option" (click)="optionClicked($event)">
            <ng-container *ngTemplateOutlet="defaultOptions; context: { entry: entry }"></ng-container>
          </mat-option>
        }
      }

      @if (optionsTemplate) {
        @for (templateOption of templateOptions; track templateOption) {
          <mat-option class="movie-selector-mat-option" (click)="optionClicked($event)">
            <ng-container *ngTemplateOutlet="optionsTemplate; context: { option: templateOption }"></ng-container>
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
</div>

<ng-template #defaultOptions let-entry="entry">
  <div class="movie-option-content" (click)="optionClicked($event)">
    <div class="movie-option-text">
      <div class="title-row">
        <p class="title">{{ entry.movie.title }}</p>
        @if (entry.format) {
          <lib-movie-format-badges
            class="format-badges"
            [codes]="entry.format.codes"
            [name]="entry.format.name"
            [hide2d]="hide2dFor(entry)"
          ></lib-movie-format-badges>
        }
      </div>
      <p class="duration">{{ entry.movie.duration }} {{ 'global.minutes' | transloco }}</p>
    </div>
    <button
      class="select-btn btn-primary btn-dark-theme cta-btn"
      (click)="selectMovie($event, entry)"
      [disabled]="entry.movie?.disabled"
      [class.btn-disabled]="entry.movie?.disabled"
    >
      {{ btnLabel | transloco }}
    </button>
  </div>
</ng-template>
